import React, { useEffect, useState } from 'react'
import { color } from '@my/util'
const { FlatList } = XPReactNative
import { useForm, Controller, useWatch } from 'react-hook-form'
import { ActiveButton, SimpleText, TextInputComponent, YStack, XStack, ToggleGroup, XPReactNative, XPModal, Button, VerticalCheckboxesControlled, Image, Group, Form, H2, useMedia } from '@my/ui'
import { CheckboxComponent, getDefaultMonthlyExpense } from '../helpers/Helper'
import { ToggleButton } from '../../../components/index'
import { newExpenseOptions } from '../data'
import images from '../../../assets/images'
import { Trash, XCircle } from '@tamagui/lucide-icons-2'

// ExpenseInput Component
const ExpenseInput: React.FC<{
  value: string
  onChangeText: (text: string) => void
  onBlur: () => void
}> = ({ value, onChangeText, onBlur }) => (
  <XStack gap={15} width={'80%'} minWidth={300}>
    <TextInputComponent
      InputIcon={images.money}
      isPassword={false}
      height={14}
      width={7}
      size={17}
      //inputWidth={'100%'}
      onChangeText={onChangeText}
      onBlur={onBlur}
      value={value}
      keyboardType="numeric"
      justifyContent={'flex-start'}
      placeHolderText={''}
      tintColor={'rgb(133, 193, 157)'}
      style={{flexGrow: 1, height: 45}}
    />
  </XStack>
)

// ToggleGroupForCategorization Component
const ToggleGroupForCategorization: React.FC<{
  value: string
  onChange: (value: string) => void
  onBlur: () => void
}> = ({ value, onChange, onBlur }) => (
  <XStack alignItems={'center'}>
    <ToggleGroup
      type="single"
      onBlur={onBlur}
      value={value}
      onValueChange={onChange}
      orientation="horizontal"
      size={'$1'}
      disableDeactivation={true}
      gap={10}
      style={{flexDirection: 'row'}}
    >
      <ToggleButton value="Need" currentValue={value} onClick={() => onChange('Need')} />
      <ToggleButton value="Want" currentValue={value} onClick={() => onChange('Want')} />
    </ToggleGroup>
  </XStack>
)

// Render Expenses Input Fields
const RenderExpenseItem: React.FC<{
  expenseItem: {
      id: string;
      label: string;
  };
  control: any
  deleteCustomExpense: (exp: any) => void;
}> = ({ expenseItem, control, deleteCustomExpense }) => {
  //if (!selectedExpenses[expenseItem.id]) return null
  //console.log({expenseItem})
  return (
    <YStack gap={15}>
      <XStack style={{alignItems: 'center'}} gap={15}>
        {expenseItem['isCustom'] ? <Button width={35} size="$2" icon={Trash} color={'red'} onPress={() => deleteCustomExpense(expenseItem)}>
          
        </Button> : null}
        <SimpleText fontSize={15} fontWeight={'300'} color={color.grey}>
          {expenseItem?.label}
          {expenseItem['isCustom'] ? <SimpleText fontSize={10} fontWeight={'400'} color={color.grey}>
            {'  '}(Custom Expense)
          </SimpleText> : null}
        </SimpleText>
      </XStack>
      <XStack
        justifyContent="space-between"
        width={'100%'}
        flexWrap="wrap"
        alignItems={'center'}
        gap={10}
        rowGap={10}
      >
        <Controller
          control={control}
          name={`Expenses - Monthly - ${expenseItem?.id}`}
          render={({ field: { onChange, value, onBlur } }) => (
            <ExpenseInput value={value} onChangeText={onChange} onBlur={onBlur} />
          )}
        />
        <Controller
          control={control}
          name={`Expenses - Categorization Mapping.${expenseItem.id}`}
          render={({ field: { onChange, value, onBlur } }) => (
            <ToggleGroupForCategorization value={value} onChange={onChange} onBlur={onBlur} />
          )}
        />
      </XStack>
    </YStack>
  )
}

const zaGreen = 'rgb(133, 193, 157)';

// Main Expenses Component
export const Expenses: React.FC<ExpensesProps> = ({ control: mainControl, financialProfileData, formMethods }) => {
  const media = useMedia();
  const [expensesModalOpen, setExpensesModalOpen] = useState<boolean>(false);
  const [customModalOpen, setCustomModalOpen] = useState<boolean>(false);
  const [customExpenseName, setCustomExpenseName] = useState('');
  useEffect(() => {
    // Manually register a "virtual" field
    formMethods.register('Expenses - Custom Map');
  }, [formMethods.register]);

  const customExpensesMap = useWatch({name: 'Expenses - Custom Map'}) || {};
  const watchedExpensesActiveMap = useWatch({name: 'Expenses - Active Map'});
  const watchedExpensesCategorizationMap = useWatch({name: 'Expenses - Categorization Mapping'});
  const selectedExpenses = watchedExpensesActiveMap ? watchedExpensesActiveMap : getDefaultMonthlyExpense(newExpenseOptions, financialProfileData);
  const closeModal = () => setExpensesModalOpen(false);
  const openModal = () => setExpensesModalOpen(true);

  const createCustomExpense = () => {
    if (customExpenseName && customExpenseName.trim()) {
      const newMap = { ...customExpensesMap, [customExpenseName]: true }
      formMethods.setValue('Expenses - Custom Map', newMap);
      //console.log(newMap, financialProfileData)
    }
    setCustomExpenseName('');
  }
  const deleteCustomExpense = (customExpenseItem: any) => {
    formMethods.unregister('Expenses - Monthly - '+customExpenseItem.id);
    
    const newMap = { ...customExpensesMap }
    delete newMap[customExpenseItem.id]
    formMethods.setValue('Expenses - Custom Map', newMap);

    const newCategorizationMap = {...watchedExpensesCategorizationMap};
    delete newCategorizationMap[customExpenseItem.id]
    formMethods.setValue('Expenses - Categorization Mapping', newCategorizationMap);
  }

  const setExpensesModal = <XPModal
    open={expensesModalOpen} 
    webContentProps={{width: '85%', maxWidth: 500, height: '85%', overflow: 'hidden'}}
    onBackgroundPress={closeModal}
    nativeModalType={'library'}
    otherProps={{style: {
      backgroundColor: 'white',
      width: '85%', maxWidth: 500, maxHeight: '70%', overflow: 'hidden', alignSelf: 'center',
      padding: 18, borderRadius: 9, marginTop: 40
    }}}
  >
    <Button onPress={closeModal} style={{ position: 'absolute', right: 5, top: 5, zIndex: 5 }}>
      {/* <Image src={XCircle} style={{ height: 17, width: 17 }} /> */}
      <XCircle style={{ height: 17, width: 17 }} />
    </Button>
    <YStack height={'100%'}>
      
      <Controller
        control={mainControl}
        name={'Expenses - Active Map'}
        render={({ field: { onChange, value } }) => (
          <VerticalCheckboxesControlled 
            items={newExpenseOptions.map((x) => ({value: x.id, label: x.label}))}
            values={value || selectedExpenses}
            onChange={onChange}
            //title='Monthly Expenses'
            title='Select each of your standard Monthly Expenses'
            containerProps={{width: '100%', height: '100%', overflow: 'auto'}}
            itemStyle={{minWidth: 300, width: '100%'}}
            //itemContainerProps={{flexDirection: 'row'}}
          />
        )}
      />
    </YStack>
  </XPModal>

  const customExpenseModal = <XPModal
    open={customModalOpen} 
    webContentProps={{width: '85%', maxWidth: 500, height: 300, overflow: 'hidden'}}
    onBackgroundPress={() => setCustomModalOpen(false)}
    nativeModalType={'library'}
    otherProps={{style: {
      backgroundColor: 'white',
      width: '90%', maxWidth: 500, maxHeight: '40%', overflow: 'hidden', alignSelf: 'center', justifySelf: 'center',
      padding: 18, borderRadius: 9, marginTop: '50%'
    }}}
  >
    <Button onPress={() => setCustomModalOpen(false)} style={{ position: 'absolute', right: 5, top: 5, zIndex: 5 }}>
      {/* <Image src={XCircle} style={{ height: 17, width: 17 }} /> */}
      <XCircle style={{ height: 17, width: 17 }} />
    </Button>
    <YStack style={{height: '100%', justifyContent: 'center', alignItems: 'center'}}>
      
      <YStack
        alignItems="center"
        //minWidth={300}
        gap="$2"
        width="100%"
        borderWidth={1}
        borderRadius="$4"
        backgroundColor="$background"
        borderColor="$borderColor"
        padding={5}

        style={{alignItems: 'center', height: '100%'}}
      >
        <H2 style={{textAlign: 'center'}}>Create a Custom Expense</H2>
        <TextInputComponent
          //InputIcon={images.money}
          isPassword={false}
          height={14}
          width={7}
          size={17}
          inputWidth={'100%'}
          onChangeText={(text) => setCustomExpenseName(text)}
          value={customExpenseName}
          //keyboardType="numeric"
          justifyContent={'flex-start'}
          placeHolderText={'Expense Name'}
          tintColor={'rgb(133, 193, 157)'}
          style={{width: '100%', height: 45}}
        />
        <ActiveButton 
          //margin="auto" 
          style={{width: 100}}
          onPress={() => {
            setCustomModalOpen(false);
            createCustomExpense();
          }}
          ButtonTextProps={{children: 'Create'}}
        />
      </YStack>
    </YStack>
  </XPModal>

  const expensesToDisplay = [...newExpenseOptions, ...Object.keys(customExpensesMap).map((id) => ({id, label: id, isCustom: true}))]
  
  //console.log({customExpensesMap, expensesToDisplay, financialProfileData})
  return (
    <YStack paddingHorizontal={15} gap={20}>
      {/* Header Section */}
      <YStack style={{gap: 15}}>
        <SimpleText fontSize={18} fontWeight={'600'} color={color.grey}>
        Can you provide a detailed breakdown of your monthly expenses by category, including housing,
        food, transportation, insurance, and other areas?
        </SimpleText>
        <XStack style={{alignItems: 'center', justifyContent: 'center'}}>
          <Group size="$3" orientation={media['max-sm'] ? 'vertical' : "horizontal"} gap={5} borderRadius={9}>
            <Group.Item>
              <ActiveButton 
                onPress={openModal}
                style={{width: 330, margin: 'auto', padding: 0 }}
                ButtonTextProps={{children: 'Select your standard Monthly Expenses' }}
              />
            </Group.Item>
            <Group.Item>
              <ActiveButton 
                onPress={() => setCustomModalOpen(true)}
                style={{width: 330, margin: 'auto', padding: 0 }}
                ButtonTextProps={{children: 'Define a custom Monthly Expense' }}
              />
            </Group.Item>
          </Group>
        </XStack>
        {setExpensesModal}
        {customExpenseModal}
      </YStack>

      {/* Expenses Input and Categorization */}
      <YStack gap={15}>
        {expensesToDisplay.map((expenseItem, index) => (

        //{Object.entries(selectedExpenses).filter(([_, isActive]) => isActive).map(([expenseId], index) => (
          (expenseItem['isCustom'] || selectedExpenses[expenseItem['id']]) ? <RenderExpenseItem
            key={expenseItem['id']}
            expenseItem={expenseItem as any}
            control={mainControl}
            deleteCustomExpense={deleteCustomExpense}
          /> : null
        ))}
      </YStack>
    </YStack>
  )
}
